import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getAppState = (state: RootState) => state.app;

export const selectOffline = createSelector(
  [getAppState],
  (appState) => appState.isOffline
);

export const selectSnackbarOpen = createSelector(
  [getAppState],
  (appState) => appState.snackbarOpen
);

export const selectLanguage = createSelector(
  [getAppState],
  (appState) => appState.language
);

export const selectSnackbarType = createSelector(
  [getAppState],
  (appState) => appState.snackbarType
);

export const selectSnackbarMessage = createSelector(
  [getAppState],
  (appState) => appState.snackbarMessage
);

export const selectCountries = createSelector(
  [getAppState],
  (appState) => appState.countries
);

export const selectBottomNavigationOpen = createSelector(
  [getAppState],
  (appState) => appState.bottomNavigationOpen
);

export const selectIsAuthenticated = createSelector(
  [getAppState],
  (appState) => appState.isLoggedIn
);

export const selectIsAuthInProgress = createSelector(
  [getAppState],
  (appState) => appState.isAuthInProgress
);

export const selectOpenUnverifiedMemberDialog = createSelector(
  [getAppState],
  (appState) => appState.openUnverifiedMemberDialog
);

export const selectResendVerificationEmailLinkCompleted = createSelector(
  [getAppState],
  (appState) => appState.resendVerificationEmailLinkCompleted
);

export const selectResendVerificationEmailLinkLoading = createSelector(
  [getAppState],
  (appState) => appState.resendVerificationEmailLinkLoading
);

export const selectIsVideoUploading = createSelector(
  [getAppState],
  (appState) => appState.uploadingVideo
);

export const selectVideoUploadResult = createSelector(
  [getAppState],
  (appState) => appState.uploadVideoResult
);

export const selectShouldOpenImagePicker = createSelector(
  [getAppState],
  (appState) => appState.shouldOpenImagePicker
);

export const selectServerDirective = createSelector(
  [getAppState],
  (appState) => appState.serverDirective
);
